import { archiveCat } from '@/pages/home/data';

export default function StyleArchive() {
  return (
    <section id="style" className="scroll-mt">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-widest text-secondary-600">
              <span className="font-display text-sm font-black text-primary-500">05</span>
              <span className="h-px w-6 bg-background-400" />
              灵感分区速查
            </div>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              黑料色风格档，按分区直接冲
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            每个分区都是独立选题：封面黑底、海报撞色、大字版式、暗调人像……想找哪一挂，点进去全是同类参考。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {archiveCat.map((c) => (
            <a
              key={c.name}
              href="#style"
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-300/60 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={c.icon} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-display text-base font-bold text-foreground-950 md:text-lg">
                    {c.name}
                  </h3>
                  <span className="shrink-0 text-xs font-medium text-primary-600">{c.count} 条</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  封面海报配色版式一站式翻完，持续更新
                </p>
              </div>
              <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-colors group-hover:text-primary-500" />
            </a>
          ))}
        </div>

        {/* 运营 CTA 带 */}
        <div className="mt-10 flex flex-col items-start justify-between gap-6 overflow-hidden rounded-lg border border-primary-300/70 bg-primary-100/60 p-6 md:flex-row md:items-center md:p-8">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-2xl text-background-50">
              <i className="ri-lightbulb-flash-line" />
            </span>
            <div>
              <h3 className="font-display text-lg font-bold text-foreground-950 md:text-xl">
                想要哪类封面配色？直接提需求
              </h3>
              <p className="mt-1 max-w-xl text-sm leading-6 text-foreground-700">
                给一句关键词（比如「想给烘焙品牌做海报配色」），我们按黑料色风格帮你挑案例，整理成一组可直接套用的参考。
              </p>
            </div>
          </div>
          <button
            type="button"
            className="flex h-11 shrink-0 cursor-pointer items-center whitespace-nowrap rounded-full bg-foreground-950 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            提个配色需求
            <i className="ri-arrow-right-line ml-2" />
          </button>
        </div>
      </div>
    </section>
  );
}